/* eslint-disable camelcase */
import { IOWidget, Pair, Action, Route, AsyncState } from 'widgets-for-react'
import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteState } from '../../../public_site.main.mod'
import { bimAndDrawingsFormState } from './request_documents'
import { Locale, PaginatedItem, SearchResultItem } from '../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeStory } from '../../drupal/types_and_parser/types'
import { PageTemplateState } from '../../cms/state/types.gen'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { CustomBlock } from '../../drupal/types_and_parser/custom_blocks.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { PublicSite_CustomPageData } from '../application.mod'
import { Block } from '../../drupal/types_and_parser/standard_blocks.gen'
import { PressReleaseItem } from '../blocks/custom_blocks/widgets/pressReleasesBlock'
import { Page } from '../../cms/page/types.gen'
import { ParsedOverviewDetailItem } from './pages/overviewPage/components/overviewItemsBlock/overview_items_block'
import { PageKind } from './pages/overviewPage/overview_page'
import { PaginatedItemStone } from '../../drupal/api/api.mod'
import { Map, List } from 'immutable'
import { FormState } from '../../form/types'
export type CustomPage<CustomPageState> = {
  widget: IOWidget<
    Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPageState>,
    Action<CustomPageState>
  >
  route: Route<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>
  setState: (s: PublicSiteState, ps: CustomPageState) => PublicSiteState
  getState: (_: PublicSiteState) => CustomPageState
  updateStateBasesOnRoute: (
    s: PublicSiteState,
    r: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>
  ) => PublicSiteState
}

export type PublicSiteCustomRoutes =
  | { kind: 'selectLocale' }
  | { kind: 'requestDocuments' }
  | { kind: 'story_overview'; page: number; lang: string; slug: string }
  | { kind: 'press'; page: string }
  | { kind: 'search_overview'; page: number; lang: string; slug: string; query: string }
  | { kind: 'styleguide' }
  | { kind: 'success'; vacancyId: string }
  | { kind: 'vacancyItem'; vacancyId: string }
  | {
    kind: 'overview', slug: string, page: number, industryTag?: string[], typeTag?: string[], searchQuery?: string,


    vacancyContractTypeTag?: string[],
    vacancyCountryTags?: string[],
    vacancyLocationTags?: string[],
    vacancyDepartmentTags?: string[],
    newsTypeTag?: string[],
    teamMemberDisciplineTag?: string[],
    testimonialTag?: string[],
  }

export type CustomPages = {
  selectLocale: CustomPage<CustomPagesState['selectLocale']>
  requestDocuments: CustomPage<CustomPagesState['requestDocuments']>
  story_overview: CustomPage<CustomPagesState['story_overview']>
  search_overview: CustomPage<CustomPagesState['search_overview']>
  styleguide: CustomPage<CustomPagesState['styleguide']>
  press: CustomPage<CustomPagesState['press']>
  overview: CustomPage<CustomPagesState['overview']>
  vacancyItem: CustomPage<CustomPagesState['vacancyItem']>
  success: CustomPage<CustomPagesState['success']>
}

export type TagTitle = string
export type TagValues = string[]

export type CustomPagesState = {
  selectLocale: {}
  success: {
    get_vacancy: AsyncState<Vacancy>
    form: FormState
  }
  requestDocuments: {
    bimAndDrawingsFormState: bimAndDrawingsFormState
  }
  story_overview: {
    overview_page: number
    storyPage: AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>>
    get_stories: AsyncState<PaginatedItem<ParsedNodeStory>>
  }
  search_overview: {
    overview_page: number
    current_query: string
    get_searches: AsyncState<PaginatedItem<SearchResultItem>>
  }
  styleguide: {}
  press: {
    page: string
    pressRelease: AsyncState<PressReleaseItem>
  },
  vacancyItem: {
    // cookiestate: CookiebarState
    get_vacancy: AsyncState<Vacancy>
    form: FormState
    current_view: "vacancy-detail" | "apply-form"
  }
  overview: {
    overview_page: AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>>
    overview_items: AsyncState<PaginatedItemStone<ParsedOverviewDetailItem>>
    tags: Map<TagTitle, AsyncState<TagValues>>
    selected_options: {
      tags: Map<TagTitle, TagValues>
      searchQuery: string
      currentPage: number
    },
    // cookiestate: CookiebarState,
    page_template_state: PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>,
    pageKind: PageKind
  }
}



// add here below your new tags. 
//note. the following two constants are also user in the tags_filter_block
//keep you code clean and compact. always reference these constants and the funcitons below
export const resourceIndustryTags = "resouceIndustryTags"
export const resourceTypeTags = "resourceTypeTags"
export const newsTypeTags = "newsTypeTags"
export const vacancyContractTypeTags = "vacancyContract"
export const vacancyStateProvinceTags = "vacancyStateProvince"
export const vacancyCountryTags = "vacancyCountry"
export const vacancyLocationTags = "vacancyLocation"
export const vacancyDepartmentTags = "vacancyDepartment"
export const teamMemberDisciplineTags = "teamMemberDiscipline"
export const paperTypeTags = "paperTypeTags"
export const eventTypeTags = "eventTypeTags"

export const testimonialTags = "testimonialTags"


export const resource_overview_tags = [resourceTypeTags, resourceIndustryTags]
export const news_overview_tags = [newsTypeTags]
export const vacancy_overview_tags = [vacancyContractTypeTags, vacancyCountryTags, vacancyLocationTags, vacancyDepartmentTags, vacancyStateProvinceTags]
export const team_overview_tags = [teamMemberDisciplineTags]
export const testimonial_overview_tags = [testimonialTags]


//this function converts the tag attribute stored in the state to the corresponding name used in the url query
export const overview_tag_to_url_tag = (overview_tag: string) => {
  let k1 = overview_tag
  switch (k1) {
    case resourceIndustryTags:
      k1 = "resourceIndustryTag"
      break
    case resourceTypeTags:
      k1 = "resourceTypeTag"
      break
    case newsTypeTags:
      k1 = 'newsTypeTag'
      break
    case vacancyContractTypeTags:
      k1 = 'vacancyContractTypeTag'
      break
      case vacancyStateProvinceTags:
        k1 = 'vacancyStateProvinceTag'
        break
    case vacancyCountryTags:
      k1 = 'vacancyCountryTag'
      break
    case vacancyLocationTags:
      k1 = 'vacancyLocationTag'
      break
    case vacancyDepartmentTags:
      k1 = 'vacancyDepartmentTag'
      break
    case teamMemberDisciplineTags:
      k1 = 'teamMemberDisciplineTag'
      break
    case testimonialTags:
      k1 = 'testimonialTag'
      break
  }
  return k1
}

export const page_kind_to_tag_list = (p: PageKind): string[] => {
  if (p == 'resource-overview') return resource_overview_tags
  if (p == 'news-overview') return news_overview_tags
  if (p == 'vacancy-overview') return vacancy_overview_tags
  if (p == 'team-overview') return team_overview_tags
  if (p == 'testimonial-overview') return testimonial_overview_tags
  return []
}

export function htmlDecode(input) {
  try {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }
  catch (e) {
    console.error(e)
    return input
  }
}
//this function converts the tag attribute stored in the state to name used in the CMS
export const overview_tag_to_taxonomy_title = (overview_tag: string) => {
  const cms_type: string = "wordpress"
  let k1 = overview_tag
  switch (k1) {
    case resourceIndustryTags:
      if (cms_type == "wordpress") {
        k1 = "resource_industry";
      }
      if (cms_type == "sharepoint") {
        k1 = "Industries";
      }
      break
    case resourceTypeTags:
      if (cms_type == "wordpress") {
        k1 = "resource_type";
      }
      if (cms_type == "sharepoint") {
        k1 = "ResourceTypes";
      }
      break
    case newsTypeTags:
      if (cms_type == "wordpress") {
        k1 = "news_type";
      }
      break
    case vacancyContractTypeTags:
      if (cms_type == "wordpress") {
        k1 = "vacancyContract_type";
      }
      break
    case vacancyCountryTags:
      if (cms_type == "wordpress") {
        k1 = "vacancyCountry_type";
      }
      break
    case vacancyLocationTags:
      if (cms_type == "wordpress") {
        k1 = "vacancyLocation_type";
      }
      break
    case vacancyDepartmentTags:
      if (cms_type == "wordpress") {
        k1 = "vacancyDepartment_type";
      }
      break
    case teamMemberDisciplineTags:
      if (cms_type == "wordpress") {
        k1 = "team-member_type";
      }
      break
    case testimonialTags:
      if (cms_type == "wordpress") {
        k1 = "testimonial_type";
      }
      break
    case paperTypeTags:
      if (cms_type == "wordpress") {
        k1 = "paper_type";
      }
      break
    case eventTypeTags:
      if (cms_type == "wordpress") {
        k1 = "event_type";
      }
      break
  }
  return k1
}





  export interface Highlight {}

  export interface InnerHits {}

  export interface Recruiter {
    Email: string
    Name: string
    PhoneNumber: string
  }

  export interface Vacancy {
    Id: string
    Name: string
    Description: string
    Price: number
    TotalRatings: number
    NumberOfRatings: number
    ImageURL?: any
    Kind: string
    Language: string
    Country: string
    City: string
    Department: string
    IsFulltime: boolean
    OriginalId: string
    Recruiter: Recruiter
    Categories?: any
  }

